import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Fetch from 'fetch-ponyfill'
import styled, { ThemeProvider } from 'styled-components'
import Markdown from 'markdown-to-jsx'
import { NoFound } from '../../asyncRoute'

import lightTheme from '../../themes/light'
import { withI18n } from '../../i18n/util'

import Layout from '../common/Layout'

const { fetch } = Fetch()

const Wrapper = styled.div`
  background: #fdfdfd;
`

const Content = styled.div`
  max-width: 1200px;
  font-size: 15px;
  padding: 240px 15px 80px 15px;
  margin: auto;
  &:before {
    content: '';
    display: block;
    background: transparent url(/static/blog/en/images/banner.png);
    background-size: cover;
    background-position: center center;
    position: absolute;
    left: 0;
    top: 44px;
    height: 200px;
    width: 100%;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: inherit !important;
    font-size: 1.2rem;
    margin: 1.5rem 0 0.5rem;
    font-weight: 600;
  }
  h1 {
    font-size: 2rem;
    margin-bottom: 1.7rem;
  }
  h3 {
    font-size: 1rem;
  }
  p {
    line-height: 1.66rem;
  }
  ul {
    list-style: initial;
    margin-left: 1rem;
  }
  a {
    &,
    &:hover,
    &:active,
    &:visited {
      font-weight: bold;
      color: #f0b90b;
    }
  }
`

const Loading = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #fff;
  border-left: 1px solid transparent;
  animation: load 0.8s infinite linear;
  align-self: center;
  @keyframes load {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

const ImageLink = styled.a.attrs({
  href: ({ src }) => src,
  target: '_blank',
})`
  background: url(${({ href }) => href});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border: 1px solid transparent;
  height: 256px;
  width: 100vw;
  max-width: 512px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1.5rem 0;
`

class BlogArticlePage extends PureComponent {
  static propTypes = {
    match: PropTypes.object,
  }

  static defaultProps = {
    match: {},
  }

  state = {}

  async componentWillMount() {
    await this.fetchContent(this.props)
  }

  componentDidMount() {
    // this sets meta robots to index,follow for SEO
    // TODO: remove in the future
    document.querySelector('meta[name="robots"]').setAttribute('content', 'index,follow')
  }

  async componentWillReceiveProps(nextProps) {
    const { match } = nextProps
    const {
      params: { locale, slug },
    } = match
    const { match: oldMatch } = this.props
    const {
      params: { locale: oldLocale, slug: oldSlug },
    } = oldMatch
    if (locale === oldLocale && slug === oldSlug) return
    await this.fetchContent(nextProps)
  }

  async fetchContent(props = this.props) {
    const { match } = props
    const {
      params: { locale, slug },
    } = match

    const res = await fetch(`/static/blog/${locale}/${slug}.md`)
    const markdown = await res.text()

    this.setState({ content: markdown, status: res.status })
  }

  render() {
    const { content, status } = this.state

    // 404?
    if (status && status !== 200) {
      return <NoFound />
    }

    let comp = <Loading />
    if (content) {
      comp = (
        <Markdown
          options={{
            overrides: {
              img: {
                component: ImageLink,
              },
            },
          }}
        >
          {content}
        </Markdown>
      )
    }

    return (
      <ThemeProvider theme={lightTheme}>
        <Layout>
          <Wrapper>
            <Content>{comp}</Content>
          </Wrapper>
        </Layout>
      </ThemeProvider>
    )
  }
}

const mapStateToProps = ({ i18n: { locale } }) => ({
  locale,
})

export default withI18n(connect(mapStateToProps)(withRouter(BlogArticlePage)))
